<script setup>const route=useRoute();defineProps(['profile']);</script>
<template><CommunityDirectory kind="experiment" :user-id="route.params.id"/></template>
